import React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Container, TextField, Button, Typography, Grid, Checkbox, FormControlLabel, Select, MenuItem, FormControl, InputLabel, Box, CircularProgress } from "@mui/material";
import { useSubmitContactUsMutation } from "../../toolkit/contactUs/contactUsApi";
import theme from "../../theme";
import { useDispatch } from "react-redux";
import { setAlertDialog } from "../../toolkit/alertDialog/alertDialogSlice";

const ContactUsForm = ({
  onSuccessCallback
}) => {

  // static data start...
  const contactUsFormInitialValues = React.useMemo(() => {
    return {
      name: "",
      email: "",
      phoneNumber: "",
      make: "",
      model: "",
      vin: ""
    };
  }, []);
  // static data end...

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // custom hooks start...
  const [submitContactUsApiHandler, submitContactUsApiData] = useSubmitContactUsMutation();
  // custom hooks end...

  // form schema start...
  const contactUsFormValidationSchema = Yup.object().shape({
    name: Yup.string().max(500)
      .required("This field is required!"),
    email: Yup.string().max(500)
      .required("This field is required!"),
    phoneNumber: Yup.string().max(500)
      .required("This field is required!"),
    make: Yup.string().max(500)
      .required("This field is required!"),
    model: Yup.string().max(500)
      .required("This field is required!"),
    vin: Yup.string().max(500)
      .required("This field is required!")
  });


  const contactUsFormik = useFormik({
    initialValues: contactUsFormInitialValues,
    validationSchema: contactUsFormValidationSchema,
    onSubmit: async (values) => {
      const payload = {
        ...values
      };

      const res = await submitContactUsApiHandler({
        payload
      });    
      
      if (res?.error) {
        dispatch(
          setAlertDialog({
            open: true,
            title: `Error!`,
            message: res?.error?.data?.error || `Some error occured!`
          })
        );
      } else if (res?.isSuccess) {
        dispatch(
          setAlertDialog({
            open: true,
            title: `Success!`,
            onOk: () => {
              if (onSuccessCallback) {
                onSuccessCallback();
              }
            }
          })
        );
      }
    }
  });
  // form schema end...

  return (
    <Grid container 
      sx={{ 
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: "100vh",
        width: "90vw",
        maxWidth: "1920px",
        margin: "0 auto"
      }}
    >
      <Grid item sx={{ 
        // width: "40%",
        padding: "1rem",
        display: "flex", 
        alignItems: "center", 
        bgcolor: "#f8f9fa",
      }}>
        <Box
          sx={{ 
            maxWidth: "45rem",
            padding: "1.5rem 2rem !important",
            boxShadow: 3, 
            borderRadius: "1.5rem",
            bgcolor: "white" 
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Contact us today!
          </Typography>
          <form onSubmit={contactUsFormik.handleSubmit}>
            <Grid container spacing={2}
              sx={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Grid item sx={{ width: "100%" }}><TextField fullWidth label="Name" name="name" {...contactUsFormik.getFieldProps("name")} error={contactUsFormik.touched.name && Boolean(contactUsFormik.errors.name)} helperText={contactUsFormik.touched.name && contactUsFormik.errors.name} /></Grid>
              <Grid item sx={{ width: "100%" }}><TextField fullWidth label="Email" name="email" {...contactUsFormik.getFieldProps("email")} error={contactUsFormik.touched.email && Boolean(contactUsFormik.errors.email)} helperText={contactUsFormik.touched.email && contactUsFormik.errors.email} /></Grid>
              <Grid item sx={{ width: "100%" }}><TextField fullWidth label="Phone Number" name="phoneNumber" {...contactUsFormik.getFieldProps("phoneNumber")} error={contactUsFormik.touched.phoneNumber && Boolean(contactUsFormik.errors.phoneNumber)} helperText={contactUsFormik.touched.phoneNumber && contactUsFormik.errors.phoneNumber} /></Grid>
              <Grid item sx={{ width: "100%" }}><TextField fullWidth label="Make" name="make" {...contactUsFormik.getFieldProps("make")} error={contactUsFormik.touched.make && Boolean(contactUsFormik.errors.make)} helperText={contactUsFormik.touched.make && contactUsFormik.errors.make} /></Grid>
              <Grid item sx={{ width: "100%" }}><TextField fullWidth label="Model" name="model" {...contactUsFormik.getFieldProps("model")} error={contactUsFormik.touched.model && Boolean(contactUsFormik.errors.model)} helperText={contactUsFormik.touched.model && contactUsFormik.errors.model} /></Grid>
              <Grid item sx={{ width: "100%" }}><TextField fullWidth label="VIN" name="vin" {...contactUsFormik.getFieldProps("vin")} error={contactUsFormik.touched.vin && Boolean(contactUsFormik.errors.vin)} helperText={contactUsFormik.touched.vin && contactUsFormik.errors.vin} /></Grid>              
            </Grid>
            <Button type="submit" variant="contained" fullWidth 
              sx={{ 
                mt: 2, bgcolor: "#4c34f0", color: "white", borderRadius: "24px", 
                fontSize: "1rem", padding: "12px" 
              }}
              disabled={submitContactUsApiData?.isLoading}
            >
              {submitContactUsApiData?.isLoading ? (
                <CircularProgress 
                  size={22}
                  sx={{
                    color: theme.palette.text.secondary,
                  }}
                />
              ) : (
                "Submit"
              )}
            </Button>
          </form>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ContactUsForm;